<div class="bg-[#F6F6F6] fixed top-0 w-full lg:px-5 px-3 flex justify-between items-center h-[58px]">

  <button class="p-2 rounded-md cursor-pointer hover:bg-[#ececec] lg:hidden block" (click)="toggleMenu()">
    <!-- Icon changes handled by parent -->
    <ng-content select="[menu-icon]"></ng-content>
  </button>


  <div class="flex gap-8 items-center">
    <a routerLink="/">
      <img src="./assets/logo/portal-logo.svg" class="size-6" alt="logo">
    </a>
    <div class="lg:block hidden">
      <app-breadcrumb></app-breadcrumb>
    </div>
  </div>


    <ul class="flex gap-1.5 items-center">
      <li class="p-2 rounded-full cursor-pointer hover:bg-[#ececec] lg:inline-block hidden" (click)="headerSearch()">
        <img src="../../../assets/images/icons/global/search.svg" alt="search">
      </li>
      <li class="p-2 rounded-full cursor-pointer hover:bg-[#ececec] lg:inline-block hidden" (click)="headerNotification()"><img
        src="../../../assets/images/icons/global/notification.svg" alt="notification"></li>

      <li class="p-2 rounded-full cursor-pointer lg:inline-block hidden">
        <app-profile></app-profile>
      </li>

      <li class="p-1.5 rounded-md cursor-pointer hover:bg-[#ececec] lg:hidden block" (click)="logout()">
        <img src="../../../assets/images/icons/global/logout.svg" alt="logout"></li>
    </ul>



</div>
